<template>
  <div>
    <h1 class="title">PER INIZIARE, PARLACI DI TE</h1>

    <div class="subtitle">
      Inserisci i tuoi dati per una
      <strong>maggior personalizzazione</strong>.<br />Tranquillo/a, non li
      utilizzeremo per inviarti fastidiosi messaggi, ma solo per
      <strong>capire al meglio le tue esigenze</strong>!
    </div>

    <form class="form" @submit.prevent>
      <Loader 
        :asyncState="asyncState"
      ></Loader>

      <div v-show="asyncState === 'success'" class="form-group">
        <select class="form-control" v-model.number="$v.form.userType.$model">
          <option :value="null" disabled>Sei un?</option>
          <option
            v-for="option in userTypes"
            v-bind:value="option.id"
            :key="option.id"
            >{{ option.name }}</option
          >
        </select>
        <div v-if="$v.form.userType.$error" class="error">
          campo obbligatorio
        </div>
      </div>

      <div v-if="form.userType">
        <div class="form-group">
          <label class="form-label hidden" for="delivery_name"
            >Come ti chiami?</label
          >
          <input
            v-model="$v.form.name.$model"
            type="text"
            placeholder="Inserisci il tuo nome"
            class="form-control"
            id="delivery_name"
          />
          <div v-if="!$v.form.name.alpha" class="error">
            utilizzare solo lettere per il nome
          </div>
          <div v-else-if="$v.form.name.$error" class="error">
            campo obbligatorio
          </div>
        </div>

        <div class="form-group">
          <label class="form-label hidden" for="email"
            >Qual è il tuo indirizzo email?</label
          >
          <input
            v-model="$v.form.email.$model"
            type="text"
            placeholder="Inserisci la tua email"
            class="form-control"
            id="email"
          />
          <div
            v-if="$v.form.email.$error && !$v.form.email.required"
            class="error"
          >
            campo obbligatorio
          </div>
          <div
            v-if="$v.form.email.$error && !$v.form.email.email"
            class="error"
          >
            il valore inserito non è un indirizzo email valido
          </div>
        </div>

        <label class="form-label hidden" for="phone_number"
          >Inserisci il tuo numero di telefono</label
        >
        <input
          v-model="$v.form.phoneNumber.$model"
          type="text"
          placeholder="Inserisci il tuo numero di telefono"
          class="form-control"
          id="phone_number"
        />
        <div
          v-if="!$v.form.phoneNumber.required && $v.form.phoneNumber.$error"
          class="error"
        >
          campo obbligatorio
        </div>
        <div v-else-if="!$v.form.phoneNumber.itPhoneNumber" class="error">
          inserire un numero telefonico corretto, es: "02123456" oppure
          "3401234567"
        </div>
        <div v-else-if="!$v.form.phoneNumber.numeric" class="error">
          si prega di indicare un numero valido senza spazio
        </div>

        <div v-if="isPrivate" class="additional-info">
          Così potremo fornirti assistenza sulla dieta se ne avessi bisogno.
        </div>
        <h2 v-else class="subtitle mt-10">
          Sarai rincontattato per uno sconto ed un offerta di collaborazione a
          te dedicata!
        </h2>

        <div v-if="isPrivate">
          <div class="form-group">
            <label class="form-label hidden" for="postal_code"
              >Dove vorresti ricevere il tuo ragù fresco?</label
            >
            <input
              v-model="$v.form.postcode.$model"
              type="text"
              placeholder="Inserisci il CAP"
              class="form-control appearance-none"
              id="postal_code"
            />
            <div
              v-if="$v.form.postcode.$error && !$v.form.postcode.required"
              class="error"
            >
              campo obbligatorio
            </div>
            <div
              v-if="$v.form.postcode.$error && !$v.form.postcode.itPostecode"
              class="error"
            >
              CAP incorretto
            </div>
          </div>

          <div class="form-group">
            <label class="form-label important-label" for="number_of_dogs">
              Quanto numeroso è il tuo branco?
            </label>
            <input
              v-model.number="$v.form.numberOfDogs.$model"
              type="number"
              @blur="checkNumberOfDogs"
              placeholder="Numero di amici a quattro zampe"
              step="1"
              min="1"
              max="9"
              class="form-control"
              id="number_of_dogs"
            />
            <div v-if="!$v.form.numberOfDogs.numeric" class="error">
              si prega di indicare un numero intero
            </div>
            <div v-else-if="$v.form.numberOfDogs.$error" class="error">
              campo obbligatorio
            </div>
          </div>

          <div v-if="showInputSameDiet" class="form-group">
            <label class="form-label important-label">
              Vuoi una dieta uguale per tutti i tuoi cani?
            </label>
            <div class="switch-container">
              <label
                for="same_diet_yes"
                class="switch-option"
                :class="[form.sameDiet ? 'active-option' : 'inactive-option']"
              >
                <input
                  v-model.number="$v.form.sameDiet.$model"
                  class="hidden"
                  type="radio"
                  id="same_diet_yes"
                  value="1"
                />
                <span>Sì</span>
              </label>
              <label
                for="same_diet_no"
                class="switch-option"
                :class="[!form.sameDiet ? 'active-option' : 'inactive-option']"
              >
                <input
                  v-model.number="$v.form.sameDiet.$model"
                  class="hidden"
                  type="radio"
                  id="same_diet_no"
                  value="0"
                />
                <span>No</span>
              </label>
            </div>
            <div v-if="$v.form.sameDiet.$error" class="error">
              campo obbligatorio
            </div>
            <div v-if="form.sameDiet" class="additional-info">
              <strong>Potrai risparmiare fino al 50%.</strong><br />Il gusto
              sarà uguale per tutti ma varierà comunque il quantitativo in base
              alle caratteristiche di ognuno. Protrai in ogni momento aggiungere
              nuovi abbonamenti o fare variazioni.
            </div>
            <div v-if="!form.sameDiet" class="additional-info">
              Ogni cane avrà la massima personalizzazione della propria pappa.
            </div>

            <div class="additional-info pt-12">
              <strong>N.B.</strong><br />Ora ti chiederemo le informazioni dei
              tuoi cani, uno alla volta.
            </div>
          </div>
        </div>
      </div>
    </form>
    
  </div>
</template>

<script>
  import {
    required,
    minValue,
    maxValue,
    numeric,
    email,
    requiredIf,
    or,
  } from "vuelidate/lib/validators";
  import { customValidators } from "../constants.js";
  import Loader from "./Loader";

  export default {
    components: {
      Loader
    },
    props: {
      wizardData: {
        type: Object,
        required: true,
      },
      dogData: {
        type: Object,
        required: true,
      },
      listData: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        form: {
          asyncState: 'pending',
          userType: null,
          name: this.wizardData.name,
          email: null,
          postcode: null,
          phoneNumber: null,
          isRemoteArea: 0,
          numberOfDogs: this.wizardData.numberOfDogs,
          sameDiet: 1,
        },
        userTypes: [],
      };
    },
    validations: {
      form: {
        userType: {
          required,
        },
        email: {
          required,
          email,
        },
        name: {
          required,
          alpha: customValidators.alpha,
        },
        postcode: {
          required: requiredIf(function() {
            return this.isPrivate;
          }),
          itPostecode: customValidators.italianPostcode,
        },
        phoneNumber: {
          required,
          numeric,
          itPhoneNumber: or(
            customValidators.italianPhoneNumber,
            customValidators.italianMobileNumber
          ),
        },
        isRemoteArea: {
          required,
        },
        numberOfDogs: {
          required: requiredIf(function() {
            return this.isPrivate;
          }),
          numeric,
          minValue: minValue(1),
          maxValue: maxValue(9),
        },
        sameDiet: {
          required: requiredIf(function() {
            return this.isPrivate;
          }),
        },
      },
    },
    computed: {
      isPrivate: function() {
        return this.form.userType == 1;
      },
      showInputSameDiet: function() {
        return this.form.numberOfDogs > 1;
      },
    },
    watch: {
      "form.postcode": function(val) {
        this.checkIsRemoteArea(val);
      },
      "form.numberOfDogs": function(after) {
        if (after == 1) this.form.sameDiet = 1;
      },
    },
    methods: {
      submit() {
        this.$v.$touch();
        return new Promise((resolve, reject) => {
          if (!this.$v.$invalid) {
            resolve({
              form: {
                userType: this.form.userType,
                name: this.form.name,
                email: this.form.email.toLowerCase(),
                postcode: this.form.postcode,
                phoneNumber: this.form.phoneNumber,
                isRemoteArea: this.form.isRemoteArea,
                numberOfDogs: this.form.numberOfDogs,
                sameDiet: this.form.sameDiet,
              },
            });
          } else {
            reject("invalid entry");
          }
        });
      },
      checkIsRemoteArea(zipCode) {
        // check if is remote area:
        // Sardegna (07010-09170), Calabria (87010-89900), Sicilia (90010-98168)
        var zip = parseInt(zipCode);
        if (
          (zip >= 7010 && zip <= 9170) ||
          (zip >= 87010 && zip <= 89900) ||
          (zip >= 90010 && zip <= 98168)
        ) {
          this.form.isRemoteArea = 1;
        } else {
          this.form.isRemoteArea = 0;
        }
      },
      checkNumberOfDogs(event) {
        // automatically change number of dogs
        // if is lower or greater than minimum or maximum.
        var value = event.target.value;
        if (parseInt(value) > 9) {
          this.form.numberOfDogs = 9;
        } else if (parseInt(value) < 1) {
          this.form.numberOfDogs = 1;
        }
      },
    },
    mounted() {
      this.asyncState = 'pending';

      let url = this.$restAPIurlRB + 'user-types';
      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          this.userTypes = data;
          this.asyncState = 'success';
        });
    },
    activated() {
      this.form.userType = this.wizardData.userType;
      this.form.name = this.wizardData.name;
      this.form.email = this.wizardData.email;
      this.form.postcode = this.wizardData.postcode;
      this.form.phoneNumber = this.wizardData.phoneNumber;
      this.form.isRemoteArea = this.wizardData.isRemoteArea;
      this.$v.$reset();
    },
  };
</script>
